<template>
  <div class="my-5">
    <div class="is-flex is-align-items-center">
      <p class="ml-3">
        <b>{{ title }}</b>
      </p>
      <a @click="addSelect" class="button is-info">הוסף אזור</a>
    </div>
    <div class="selects mt-3">
      <div
        v-for="(select, index) in selects"
        :key="index"
        class="is-flex is-align-items-center mb-4">
        <button class="button is-danger ml-3" @click="removeSelect(index)">
          הסר
        </button>
        <select
          v-model="select.value"
          @change="onSelectChange(select.value, index)"
          dir="rtl">
          <option disabled>NOT SELECTED</option>
          <option
            v-for="option in availableOptions"
            :key="option.value"
            :value="option"
            :disabled="option.selected">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OutsourceArea',
  props: {
    areas: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'אזור'
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selects: []
    }
  },
  computed: {
    selectedValues () {
      return this.selects.map((item) => item.value).filter(Boolean)
    },
    availableOptions () {
      const selectedValues = this.selectedValues.map((s) => s.value)
      return this.areas.map((area) => {
        if (selectedValues.includes(area.value)) {
          area.selected = true
        } else {
          area.selected = false
        }
        return area
      })
    }
  },
  created () {
    this.initializeSelects()
  },
  methods: {
    initializeSelects () {
      const selects = this.value.map((item) => ({ value: { ...item, selected: true } }))
      this.selects = [...selects]
      if (!this.selects.length) {
        this.addSelect()
      }
    },
    addSelect () {
      this.selects.push({ value: null })
    },
    removeSelect (index) {
      this.selects.splice(index, 1)
      if (this.selects.length === 0) {
        this.addSelect()
      }
      this.emitSelected()
    },
    onSelectChange (value, index) {
      this.selects[index].value = value
      this.emitSelected()
    },
    emitSelected () {
      this.$emit(
        'input',
        this.selectedValues.map(({ text, value }) => ({
          text,
          value
        }))
      )
    }
  }
}
</script>
